module.exports = __webpack_public_path__ + "img/IMG_0763.0463e6dc.jpg";